import { useTranslation } from 'react-i18next';
import { VdsButton } from '@volt/volt-extended-components-react';
import { FaultLevel } from '@customer/store/slices/globalSlice';
import { useNavigate } from 'react-router-dom';
import AssetHealthCards from '../asset-health-cards/AssetHealthCards';
import DashboardSection from '../dashboard-section/DashboardSection';

const MAX_CARDS = 12;
const FAULT_LEVEL = FaultLevel.One;

export function HealthSummary() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onClickViewAll = () => {
    navigate('/health/summary');
  };

  return (
    <DashboardSection
      title={t('CasHealthSummary')}
      subtitle={t('AssetsWithLevelFaults', { level: FAULT_LEVEL })}
      tooltip={t('ShowingLimitedAssets', { limit: MAX_CARDS })}
      action={
        <VdsButton variant="secondary" onClick={onClickViewAll}>
          {t('SummaryDetails')}
        </VdsButton>
      }
    >
      <AssetHealthCards limit={MAX_CARDS} faultLevel={FAULT_LEVEL} />
    </DashboardSection>
  );
}

export default HealthSummary;
